import request from '@/utils/request2';
export function questionnaireRecordList(data) {
  return request.post('admin/questionnaire/record', data);
}